import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const CardSwiper = ({ iconUrl, iconAlt, title, content }) => (React.createElement("div", { className: 'card-swiper-root' },
    React.createElement(ImgV2, { src: iconUrl, alt: iconAlt }),
    React.createElement("p", { className: "h5-bold" }, title),
    content && React.createElement("p", { dangerouslySetInnerHTML: {
            __html: content,
        }, className: "p-regular" })));
